<template>
	<div>
		<base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
			<AdminMenu />
		</base-header>
		<div class="container-fluid mt--7">
			<div class="row">
				<div class="col">
					<div class="alert alert-success alert-dismissible fade show" role="alert" v-if="success">
						<span class="alert-icon"><i class="ni ni-like-2"></i></span>
						<span class="alert-text"><strong>Success!</strong> Your info has been updated!</span>
						<button type="button" class="close" data-dismiss="alert" @click.prevent="success = false;" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card" v-if="!userId">
						<div class="card-header border-0">
							<h3 class="mb-0">Users</h3>
						</div>
						<table class="table align-items-center">
							<thead class="thead-light">
								<tr>
									<th scope="col" class="sort" data-sort="name">Name</th>
									<th scope="col" class="sort" data-sort="email">Email</th>
									<th scope="col">Roles</th>
									<th scope="col"></th>
								</tr>
							</thead>
							<tbody class="list">
								<tr v-for="user in users" v-bind:key="user._id">
									<td>{{ user.name }}</td>
									<td>{{ user.email }}</td>
									<td>{{ user.roles }}</td>
									<td class="text-right">
										<a class="btn btn-sm btn-icon-only text-white btn-info" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click.prevent="editUser(user)">
											<i class="fas fa-user-edit"></i>
										</a>
										<a class="btn btn-sm btn-icon-only text-white btn-danger" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click.prevent="deleteUser(user)">
											<i class="fas fa-user-slash"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card" v-else>
						<div class="card-header border-0">
							<h6 class="heading-small text-muted mb-4">User information</h6>
						</div>
						<div class="container-fluid">
							<form @submit.prevent="save">
								<div class="pl-lg-4">
									<div class="row">
										<div class="col-lg-6">
											<base-input alternative=""
														label="Email address"
														placeholder="jesse@example.com"
														input-classes="form-control-alternative"
														v-model="user.email"
											/>
										</div>
										<div class="col-lg-6">
											<base-input alternative=""
														label="Name"
														placeholder="Name"
														input-classes="form-control-alternative"
														v-model="user.name"
											/>
										</div>
									</div>
								</div>
								<hr class="my-4" />
								<h6 class="heading-small text-muted mb-4">Organization Information</h6>
								<div class="pl-lg-4">
									<div class="row">
										<div class="col-md-6">
											<base-input alternative=""
														label="Corporation / Legal Name"
														placeholder="Organization Name"
														input-classes="form-control-alternative"
														v-model="organization.name"
											/>
										</div>
										<div class="col-md-6">
											<base-input alternative=""
														label="Partner ID (PID)"
														placeholder="Partner ID"
														input-classes="form-control-alternative"
														v-model="organization.pid"
											/>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12">
											<base-input alternative=""
														label="Address"
														placeholder="Address"
														input-classes="form-control-alternative"
														v-model="organization.address"
											/>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-4">
											<base-input alternative=""
														label="City"
														placeholder="City"
														input-classes="form-control-alternative"
														v-model="organization.city"
											/>
										</div>
										<div class="col-lg-4">
											<base-input alternative=""
														label="State"
														placeholder="State"
														input-classes="form-control-alternative"
														v-model="organization.state"
											/>
										</div>
										<div class="col-lg-4">
											<base-input alternative=""
														label="Postal code"
														placeholder="Postal code"
														input-classes="form-control-alternative"
														v-model="organization.zipCode"
											/>
										</div>
									</div>
									<div class="card-footer text-right">
										<button type="submit" class="btn btn-primary">Save</button>
										<button type="button" class="btn btn-danger" data-toggle="tooltip" data-placement="top" title="Disable User" @click.prevent="disableUser(user)"><i class="fas fa-user-slash"></i></button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import AdminMenu from '@/components/AdminMenu'
	export default {
		name: 'AdminUsers',
		data () {
			return {
				apiKey: false,
				users: [],
				user: false,
				organization: {},
				success: false
			};
		},
		components: {
			AdminMenu
		},
		computed: {
			APIKey () {
				const { APIKey } = this.$FeathersVuex.api;
				return APIKey;
			},
			Organization () {
				const { Organization } = this.$FeathersVuex.api;
				return Organization;
			},
			User () {
				const { User } = this.$FeathersVuex.api;
				return User;
			},
			userId () {
				return this.$route.params.id;
			}
		},
		watch: {
			async userId () {
				if (this.userId) {
					this.user = await this.User.get(this.userId);
					this.getOrganization();
				}
			}
		},
		methods: {
			async save () {
				this.success = false;
				if (this.organization.name) {
					await this.organization.save();
				}
				await this.user.save();
				this.success = true;
			},
			async createAPIKey () {
				this.$store.dispatch('api-keys/create', {}).then(res => {
					this.apiKey = res.apiKey;
					this.user.setupApiKey = true;
					this.user.save();
				});
			},
			async removeAPIKey () {
				await this.$store.dispatch('api-keys/remove', this.apiKey);
				this.apiKey = false;
			},
			renderAPIKey () {
				this.$store.dispatch('api-keys/find', { query: { userId: this.userId } }).then(res => {
					if (res.data.length) {
						this.apiKey = res.data[0].apiKey;
					}
				});
			},
			editUser (user) {
				this.$router.push({ name: 'admin-users', params: { id: user._id } });
			},
			disableUser (user) {
				alert('DELETE! ' + user._id);
			},
			async getOrganization () {
				const organization = await this.Organization.find({ query: { userId: this.userId } });
				if (organization.total > 0) {
					this.organization = organization.data[0];
					this.renderAPIKey();
				} else {
					this.organization = new this.Organization;
				}
			}
		},
		async mounted () {
			const users = await this.User.find();
			this.users = users.data;
			if (this.userId) {
				this.user = await this.User.get(this.userId);
				this.getOrganization();
			}
		}
	};
</script>
<style></style>
